import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { doNothing } from '../../helpers/functions/doNothing'
import type {
  LinkWithData,
  Asset,
  OnShowAssetPickerProps,
  OnLinkDataUpdate,
} from '../../helpers/types'
import { Single } from './displays'
import { baseStyles } from './styles'

interface Props {
  accountImage: Asset | null
  accountName: string
  accountUsername: string
  assets?: Asset[]
  content: string
  display: string
  isPresenting: boolean
  linksWithData?: LinkWithData[]
  onExpandAsset?: (assetId: number) => void
  onRemoveAsset?: (assetId: number) => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  postType: string
  readOnly: boolean
  scheduledAt: string
  timezone: string
  updateAssets?: (assets: AssetReference[]) => void
  updateCaption?: (value: string, assetId: number) => void
  updateLinkData?: OnLinkDataUpdate
  updateText?: (val: string, destination: string) => void
}

const displays = {
  mobileSingle: Single,
  default: Single,
}

const isValidDisplay = (display: string): display is keyof typeof displays =>
  display in displays

export const BlueskyStandard: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  assets,
  content,
  display,
  isPresenting,
  linksWithData,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly,
  updateAssets,
  updateCaption,
  updateLinkData,
  updateText,
}) => {
  const RenderDisplay = isValidDisplay(display)
    ? displays[display]
    : displays.default

  return (
    <div
      css={baseStyles}
      className={kuiperClassNames(
        'bluesky bluesky-standard',
        `bluesky-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        assets={assets || []}
        display={display}
        content={content}
        isPresenting={isPresenting}
        linksWithData={linksWithData || []}
        onAssetChange={
          updateAssets
            ? (val: AssetReference[]) => updateAssets(val)
            : doNothing
        }
        onContentChange={
          updateText ? (val: string) => updateText(val, 'content') : doNothing
        }
        onExpandAsset={onExpandAsset || doNothing}
        onLinkDataUpdate={updateLinkData || doNothing}
        onRemoveAsset={onRemoveAsset || doNothing}
        onShowAssetPicker={onShowAssetPicker || doNothing}
        readOnly={readOnly}
        updateCaption={updateCaption || doNothing}
      />
    </div>
  )
}
